var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.googleMapsAccepted)?_c('MapLoader',{attrs:{"apiKey":_vm.googleMapsApiKey,"locations":_vm.projectLocations,"minMaxBounds":_vm.minMaxBounds},on:{"bounds-changed":_vm.onBoundsChanged}}):_vm._e(),(!_vm.googleMapsAccepted)?_c('MapPlaceholder'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }